var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000pt",
    height: "500pt",
    viewBox: "280 430 1450 300",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1167.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3471 6003 c0 -856 4 -1509 9 -1498 5 11 9 40 9 65 2 71 38 206 81 297 114 243 318 417 582 494 61 18 107 22 286 26 l212 5 0 604 0 604 768 0 c493 0 790 -4 828 -11 306 -54 492 -233 560 -541 21 -92 23 -315 5 -418 -41 -230 -153 -396 -326 -481 -160 -78 -79 -73 -1230 -79 -1004 -5 -1032 -6 -1100 -26 -222 -66 -405 -194 -525 -369 -81 -117 -141 -292 -154 -448 l-5 -68 1467 4 c1309 3 1477 5 1562 20 279 49 464 104 650 193 178 86 298 170 435 308 149 150 237 278 311 456 l23 55 1 -517 0 -518 2358 0 2358 0 689 1129 c380 622 694 1126 698 1122 4 -4 315 -511 691 -1127 l684 -1119 606 -3 607 -2 -13 24 c-7 13 -469 769 -1027 1680 l-1014 1656 -540 -2 -540 -3 -754 -1232 -755 -1233 -1434 0 -1434 0 0 170 0 170 1074 0 1073 0 6 68 c4 37 7 239 7 450 l0 382 -1080 0 -1080 0 0 165 0 165 1435 0 1435 0 0 450 0 450 -2025 0 -2025 0 -2 -512 -3 -512 -28 70 c-40 97 -124 235 -201 331 -217 269 -559 466 -966 557 -275 61 -221 59 -1802 63 l-1448 4 1 -1518z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDea);
export default __webpack_public_path__ + "static/media/logo_dea.3a2568ce637f50d0862bf2dcf3b4a211.svg";
export { ForwardRef as ReactComponent };